export enum RankingActionTypes {
  RECEIVED_SUCCESS = 'ranking/RECEIVED_SUCCESS',
  RECEIVED_ERROR = 'ranking/RECEIVED_ERROR',
  RECEIVED_REQUEST = 'ranking/RECEIVED_REQUEST',
}
